export const isPrysmViewEnabled = () =>
  ["1", "true"].includes(localStorage.getItem("PrysmView") || "");
